import React, { Fragment, useEffect, useState } from 'react';
import {
    faArrowRight,
    faPaperPlane,
    faHourglass,
    faPencilAlt,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { academicProgramsService } from '../../../../services';
import { Confirm } from '../../../blocks';
import { onChangeFunction } from '../../../../shared';
import { Input } from 'reactstrap';

const mergeDestinationProgramId = (requestDetails, log) =>
    requestDetails?.programID ?? requestDetails?.programId ?? log.newFieldValue;

export const InstitutionRequestLogHistory = ({
    requestLogs,
    requestStatus,
    requestDetails,
}) => {
    const [timelineData, setTimelineData] = useState(requestLogs);
    const [instComments, setComments] = useState('');
    useEffect(() => {
        setTimelineData(requestLogs);
    }, [requestLogs]);
    const createTimelineGrouped = () => {
        const timeline = [];
        const logs = timelineData;
        console.log(logs);
        if (logs == null || logs.length === 0) return timeline;
        const groupedData = logs.reduce((acc, item) => {
            if (!acc[item.timeStamp]) {
                acc[item.timeStamp] = [];
            }
            acc[item.timeStamp].push(item);
            return acc;
        }, {});
        Object.entries(groupedData).map(([timeStamp, logs]) => {
            if (logs.length === 1) {
                const log = logs[0];
                log.timeStamp = new Date(log.timeStamp).toLocaleDateString('en-US');
                timeline.push(
                    <li key={log.requestID} className="timeline-item">
                        {log.fieldName === 'createdOn' && (
                            <>
                                <div className="timeline-icon">
                                    <i className="far fa-paper-plane"></i>
                                </div>
                                <div className="timeline-content">
                                    <label className="text-600 d-block mb-3">
                                        {log.timeStamp} - Request Submitted
                                    </label>
                                    <p className="text-italic mb-0">
                                        Request type: {log.newFieldValue}
                                    </p>
                                </div>
                            </>
                        )}
                        {log.fieldName === 'statusId' && (
                            <>
                                <div className="timeline-icon bg-primary text-white">
                                    <i className="far">
                                        <FontAwesomeIcon icon={faHourglass} />
                                    </i>
                                </div>
                                <div className="timeline-content">
                                    <label className="text-600 d-block mt-1">
                                        {log.timeStamp} - Commission moved request to “
                                        {log.newFieldValue}”
                                    </label>
                                    <p className="text-italic mb-0">{log.comment}</p>
                                </div>
                            </>
                        )}
                        {log.fieldName === 'comment' && (
                            <>
                                <div className="timeline-icon bg-primary text-white">
                                    <i className="far">
                                        <FontAwesomeIcon icon={faHourglass} />
                                    </i>
                                </div>
                                <div className="timeline-content">
                                    <label className="text-600 d-block mt-1">
                                        {log.timeStamp} - Commission sent back to
                                        institution for review
                                    </label>
                                    <p className="text-italic mb-0">
                                        {log.newFieldValue}
                                    </p>
                                </div>
                            </>
                        )}
                        {log.fieldName === 'Merged Program Id' && (
                            <>
                                <div className="timeline-icon">
                                    <i className="far">
                                        <FontAwesomeIcon icon={faHourglass} />
                                    </i>
                                </div>
                                <div className="timeline-content">
                                    <p className="text-italic mb-0">
                                        Being merged with Program ID:{' '}
                                        {mergeDestinationProgramId(requestDetails, log)}
                                    </p>
                                </div>
                            </>
                        )}
                        {log.fieldName !== 'createdOn' &&
                            log.fieldName !== 'statusId' &&
                            log.fieldName !== 'comment' &&
                            log.fieldName !== 'Merged Program Id' && (
                                <>
                                    <div
                                        className={`timeline-icon ${log.cheAction ? 'bg-primary text-white' : ''
                                            }`}
                                    >
                                        <i className="far">
                                            <FontAwesomeIcon icon={faPencilAlt} />
                                        </i>
                                    </div>
                                    <div className="timeline-content">
                                        <label className="text-600 d-block mb-3">
                                            {log.timeStamp} - Submission{' '}
                                            {log.comment === 'initial'
                                                ? 'Created '
                                                : 'Edited '}
                                            {log.cheAction ? 'by Commission' : ''}
                                        </label>
                                        <h5 className="text-600 text-italic mb-2">
                                            {log.fieldName}
                                        </h5>
                                        <div className="d-lg-flex align-items-center mb-3">
                                            <div className="old-value">
                                                {log.oldFieldValue}
                                            </div>
                                            <div className="mx-3">
                                                <i className="far">
                                                    <FontAwesomeIcon
                                                        icon={faArrowRight}
                                                    />
                                                </i>
                                            </div>
                                            <div className="new-value">
                                                {log.newFieldValue}
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}
                    </li>
                );
            } else {
                const timeStamp = new Date(logs[0].timeStamp).toLocaleDateString('en-US');
                const refLog = logs[0];
                timeline.push(
                    <li key={refLog.requestID} className="timeline-item">
                        <div
                            className={`timeline-icon ${refLog.cheAction ? 'bg-primary text-white' : ''
                                }`}
                        >
                            <i className="far">
                                <FontAwesomeIcon icon={faPencilAlt} />
                            </i>
                        </div>
                        <div className="timeline-content">
                            <label className="text-600 d-block mb-3">
                                {timeStamp} - Submission{' '}
                                {refLog.comment === 'initial' ? 'Created ' : 'Edited '}
                                {refLog.cheAction ? 'by Commission' : ''}
                            </label>
                            {logs
                                .filter(log => log.fieldName === 'Merged Program Id')
                                .map(log => (
                                    <>
                                        <div className="d-lg-flex align-items-center mb-3">
                                            <p className="text-italic mb-0">
                                                Being merged with Program ID:{' '}
                                                {mergeDestinationProgramId(requestDetails, log)}
                                            </p>
                                        </div>
                                    </>
                                ))}
                            {logs
                                .filter(
                                    log =>
                                        log.fieldName !== 'Additional Comments' &&
                                        log.fieldName !== 'Merged Program Id'
                                )
                                .map(log => (
                                    <>
                                        <h5 className="text-600 text-italic mb-2">
                                            {log.fieldName}
                                        </h5>
                                        <div className="d-lg-flex align-items-center mb-3">
                                            <div className="old-value">
                                                {log.oldFieldValue}
                                            </div>
                                            <div className="mx-3">
                                                <i className="far">
                                                    <FontAwesomeIcon
                                                        icon={faArrowRight}
                                                    />
                                                </i>
                                            </div>
                                            <div className="new-value">
                                                {log.newFieldValue}
                                            </div>
                                        </div>
                                    </>
                                ))}
                            {logs
                                .filter(log => log.fieldName === 'Additional Comments')
                                .map(log => (
                                    <>
                                        <h5 className="text-600 text-italic mb-2">
                                            {log.fieldName}
                                        </h5>
                                        <div className="d-lg-flex align-items-center mb-3">
                                            <p className="text-italic mb-0">
                                                {log.newFieldValue}
                                            </p>
                                        </div>
                                    </>
                                ))}
                        </div>
                    </li>
                );
            }
        });
        return timeline;
    };
    const changeStatus = statusId => {
        const logs = requestLogs;
        if (logs == null || logs.length === 0) return false;
        const refLog = logs[0];
        const postData = {
            comments: instComments,
            distanceEdApproved: {
                id: 1,
            },
        };
        const res = academicProgramsService.changeProgramRequestStatus(
            refLog.requestId,
            statusId,
            postData
        );
        Promise.resolve(res).then(data => {
            const res2 = academicProgramsService.getProgramRequestLogs(refLog.requestId);
            Promise.resolve(res2).then(data => {
                const wrappedData = { requestLogs: data };
                setTimelineData(data);
            });
        });
    };
    return (
        <Fragment>
            <section className="request-history">
                <h5 className="text-muted mb-4">Request History</h5>
                <div
                    className={`timeline-container ${requestStatus === 'Awaiting Institution'
                            ? 'institution-response'
                            : ''
                        }`}
                >
                    <ul className="history-timeline">{createTimelineGrouped()}</ul>
                </div>
                {requestStatus === 'Awaiting Institution' && (
                    <div className="request-actions response-area">
                        <h2 className="mb-0 text-right">
                            <span className="badge badge-round badge-danger p-2">
                                <i className="fas fa-exclamation-circle"></i> Action
                                Required
                            </span>
                        </h2>
                        <div className="row align-items-center">
                            <div className="col-md mb-3 mb-md-0">
                                <label>Awaiting Your Response</label>
                                <Input
                                    type="textarea"
                                    rows="6"
                                    placeholder="Place Comments Here"
                                    onChange={e => setComments(e.target.value)}
                                    name="comments"
                                    value={instComments}
                                />
                            </div>
                            <div className="col-md-auto">
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={() => changeStatus(1)}
                                >
                                    Acknowledge
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </section>
        </Fragment>
    );
};
